import React from "react";
import { CheckBoxInput } from "../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { facilityAction } from "../../_store";

function SecuritySetup({ errorMessage }) {
  const dispatch = useDispatch();

  const facilityInformationData = useSelector((x) => x?.facility?.facilityData);

  const handleSecurityChanges = (e) => {
    const { name, checked } = e?.target;
    let facilityData = { ...facilityInformationData };
    facilityData[name] = checked ? 1 : 0;
    dispatch(facilityAction.setFacilityData(facilityData));
  };

  return (
    <div className="mt-3 mb-3">
      <h4 className="inner-header-bg text-color" style={{ cursor: "pointer" }} title="To enable security questions in the inmate login with an option to display the shuffle keyboard"><i className='fas fa-lock me-2'></i>Security Setup</h4>
      <div className="row mb-12">
        <div className="col-sm-6 col-md-6">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label="Security Questions"
              name="IsSQ"
              id="IsSQ"
              handleClick={handleSecurityChanges}
              checked={facilityInformationData?.IsSQ}
              errorMessage={errorMessage}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label="Keyboard Shuffle"
              name="IsKS"
              id="IsKS"
              handleClick={handleSecurityChanges}
              checked={facilityInformationData?.IsKS}
              errorMessage={errorMessage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(SecuritySetup);
